import { useSelector } from "react-redux";
import { offlineModeService } from "../OfflineMode/offlienModeService";

const CustomToastModal = () => {
    const { customToastInstanceArray } = useSelector((state) => state.extractText);
    const { isRoomConnected } = useSelector((state) => state.commonReducer);

    return (
        <>
            {(isRoomConnected || offlineModeService.isUploading) &&
                customToastInstanceArray?.map((toast) => (
                    <div key={`custom-toast-${toast.id}`} className='custom-toastify'>
                        <div className='custom-toastify-box'>
                            <div className='custom-toastify-left'>
                                {toast.isLoading && <div className='round-loader toastify-loader default-loader'></div>}
                                <div className='custom-toastify-text'>
                                    <p>{toast.message}</p>
                                </div>
                            </div>
                            {toast.showCloseIcon && (
                                <div className='custom-toastify-close'>
                                    <button className='btn close-btn'>
                                        <span className='btn-icon icon-close-light'></span>
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                ))}
        </>
    );
};

export default CustomToastModal;
